import { createApp, h } from 'vue'
import { createInertiaApp } from '@inertiajs/vue3'
import DefaultApp from './App.vue'
// Vuetify
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import VueTheMask from 'vue-the-mask'

import { createPinia } from 'pinia'

const vuetify = createVuetify({
  components,
  directives,
  defaults: {
    global: {
      ripple: false,
      elevation: 0,
      
    },
    VSheet: {
      elevation: 0,
    },
  }
})
createInertiaApp({
  resolve: name => require(`./Pages/${name}.vue`),
  setup({ el, App, props, plugin }) {
    createApp({ render: () => h(DefaultApp, h(App, props)) })
      .use(vuetify)
      .use(plugin)
      .use(VueTheMask)
      .use(createPinia())
      .mount(el)
  },
})
